/* ISO Diamant — Protezione ordine minimo €150 sulle frese singole (property _iso_single).
   Livello client: disabilita il checkout se 0 < subtotale singole < soglia.
   Il blocco invalicabile lato server resta la cart validation function / app minimum order. */
(function () {
  'use strict';

  var THRESHOLD = 15000; /* cent — allineato al kit builder */

  function money(cents) {
    return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
  }

  function check() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var singles = 0;
        (cart.items || []).forEach(function (it) {
          if (it.properties && (it.properties._iso_single || it.properties['_iso_single'])) {
            singles += it.final_line_price != null ? it.final_line_price : it.line_price;
          }
        });
        var blocked = singles > 0 && singles < THRESHOLD;
        apply(blocked, singles);
      })
      .catch(function () { /* mai bloccare per un errore di rete */ apply(false, 0); });
  }

  function apply(blocked, singles) {
    document.documentElement.classList.toggle('iso-cart-guard-active', blocked);
    document.querySelectorAll('.iso-cart-guard-msg').forEach(function (m) { m.remove(); });
    if (!blocked) return;
    var msg = document.createElement('div');
    msg.className = 'iso-cart-guard-msg';
    msg.innerHTML = 'Il kit di frese singole richiede un minimo di <strong>' + money(THRESHOLD) + '</strong>. ' +
      'Ora ne hai ' + money(singles) + ': aggiungi altre frese dal configuratore oppure rimuovi tutte le singole per procedere.';
    var targets = document.querySelectorAll('.cart__ctas, .cart-drawer__footer, .cart__footer .cart__blocks');
    if (targets.length) {
      targets.forEach(function (t) { t.parentNode.insertBefore(msg.cloneNode(true), t); });
    }
  }

  function watch() {
    /* Ricontrolla dopo ogni chiamata al carrello (Dawn usa fetch per change/add/update) */
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var p = origFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(check, 250); });
      }
      return p;
    };
    document.addEventListener('iso:cart-updated', function () { setTimeout(check, 100); });
  }

  function boot() {
    var onCartContext = document.querySelector('.cart-items, cart-drawer, .cart__footer, #main-cart-footer');
    watch();
    if (onCartContext) check();
    /* il drawer può montarsi dopo */
    setTimeout(check, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
